import { Stack } from "@mui/material";
import ContentText from "./ContentText";
import ContentAnswer from "./ContentAnswer";
import ContentCriteria from "./ContentCriteria";

interface ContentProps {
  skillId?: string;
  isEditing: boolean;
  isMultiChoiceQuestion: boolean;
}

const Content = ({ skillId, isEditing, isMultiChoiceQuestion }: ContentProps) => {
  return (
    <Stack spacing={2.5}>
      <ContentText
        isEditing={isEditing}
        skillId={skillId}
      />
      <ContentAnswer
        isEditing={isEditing}
        skillId={skillId}
      />
      {!isMultiChoiceQuestion && (
        <ContentCriteria
          isEditing={isEditing}
          skillId={skillId}
        />
      )}
    </Stack>
  );
};

export default Content;
